<template>
    <v-bottom-sheet v-model="shows" fullscreen persistent @input="emit" content-class="bottom-sheet">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card flat tile class="bottom-sheet__card">
            <v-card-title class="bottom-sheet__card__head primary">
                <span> {{ title }} </span>
                <v-btn small text fab tile absolute right color="white" @click="exit">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider />
            <v-layout column justify-center class="bottom-sheet__card__body" v-bind="{ style: style_body }">
                <slot />
            </v-layout>
            <template v-if="!hideFoot">
                <v-divider />
                <v-layout justify-center class="bottom-sheet__card__foot">
                    <slot name="foot" />
                </v-layout>
            </template>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: {
        /** @type {import('vue').PropType<boolean>} */
        value: { type: Boolean, default: false }, // shows

        /** @type {import('vue').PropType<boolean>} */
        loading: { type: Boolean, default: false },

        /** @type {import('vue').PropType<boolean>} */
        hideFoot: { type: Boolean, default: false },

        /** @type {import('vue').PropType<string>} */
        title: { type: String, default: null },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        ...mapState("ui", ["window"]),
        style_body() {
            let footHeight = (() => {
                let { innerWidth } = this.window;
                if (innerWidth < 768) return 82;
                return 88;
            })();
            return {
                flexBasis: `calc(100vh - 58px - 1px${this.hideFoot ? "" : ` - 1px - ${footHeight}px`})`,
            };
        },
    },
    methods: {
        sync() {
            this.shows = this.value;
        },
        emit() {
            this.$emit("input", this.shows);
        },
        exit() {
            this.shows = false;
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep() .bottom-sheet {
    max-width: unset;
}

.bottom-sheet {
    &__card {
        display: flex;
        flex-direction: column;

        &__head {
            justify-content: center;
            color: white;
        }

        &__body {
            flex-grow: 0;
            flex-shrink: 0;
            overflow: hidden;
            position: relative;
        }

        &__foot {
            flex-grow: 0;
            flex-shrink: 1;
            flex-basis: auto;
            padding: 16px;
            gap: 8px;
        }
    }
}
</style>
